module.exports = __webpack_public_path__ + "media/coffee-preferences/acidity_low-7029d481.png";